import type { ComponentProps } from "react"
import { AutocompleteChips } from "@motleyhand/design"
import FormControl from "./FormControl"

type Props = Omit<
  ComponentProps<typeof AutocompleteChips>,
  "onChange" | "value"
> & {
  name: string
  required?: boolean
}

export default function FormAutocompleteChips({
  name,
  required,
  ...props
}: Props) {
  return (
    <FormControl name={name} required={required}>
      {({ field: { value, onChange }, isError, error }) => (
        <AutocompleteChips
          value={(value ?? []) as string[]}
          onChange={onChange}
          isError={isError}
          error={error}
          {...props}
        />
      )}
    </FormControl>
  )
}
